const ProductImage = ({imageUrl, altText, width = 84, height = 104}) => {
  const fallbackImage = '/static/media/placeholder.7534730b7b518f895406.jpg'

  return (
    <div className="image-wrapper">
      <img
        src={imageUrl || fallbackImage}
        width={width}
        height={height}
        className="product-image rounded"
        alt={altText || 'Product image'}
      />
    </div>
  )
}

export default ProductImage
